import { Button, Radio } from "antd";
import { useState } from "react";

import { EDIT } from "@utils/constants";
import { ReminderRecurrenceModalContent, CURRENT_ITEM } from "../constants";
import { CloseOutlined } from "@ant-design/icons";
import { noop } from "lodash";

export function DeleteAllRecurrence({ clearRecurrence, setDeleteAllRecurrenceModalOpen }: any) {
  return (
    <RecurrenceInfoModal>
      <div className="reminders-delete-all__modal__title">Deleting all Recurring reminder series.</div>
      <div className="reminders-delete-all__modal__subTitle">Clearing the recurrence and saving will delete all the recurring reminders associated.</div>
      <div className="reminders-delete-all__modal__actions">
        <div className="reminders-delete-all__modal__actions__delete">
          <Button
            type="primary"
            onClick={() => {
              clearRecurrence();
            }}
          >
            Delete
          </Button>
        </div>
        <div className="reminders-delete-all__modal__actions__cancel">
          <Button onClick={() => setDeleteAllRecurrenceModalOpen(false)}>Cancel</Button>
        </div>
      </div>
    </RecurrenceInfoModal>
  );
}

export function RecurrenceInfoModal({ children}: any) {
  return (
    <div className="reminders-delete-all">
      <div className="reminders-delete-all__modal-backDrop"></div>
      <div className="reminders-delete-all__modal">{children}</div>
    </div>
  );
}


export function EditAllRecurrence({ toggleModal = noop, metaDataKey = EDIT, radioButtonVal = false , closeModal = noop, setModalData = noop, onOk = noop}: any) {

  const {title , body__title , body__radio_group , cancel__button_text , primary__button_text} = ReminderRecurrenceModalContent[metaDataKey] || {};

  const [operationRange , setOperationRange] = useState<string>(CURRENT_ITEM);


  function handleRadioChange(e :any) {
      setModalData(e.target.value)
      setOperationRange(e.target.value)
  }

  return (
    <RecurrenceInfoModal>
      <div className="editRecurrenceReminderModal__header">
        <div className="editRecurrenceReminderModal__header__title">{title}</div>
        <div className="editRecurrenceReminderModal__header__close-modal" onClick={()=>{closeModal();toggleModal();}}><CloseOutlined /></div>
      </div>
      <div className="editRecurrenceReminderModal__body">
        <div className="editRecurrenceReminderModal__body__title">{body__title}</div>
        <Radio.Group className="editRecurrenceReminderModal__body__radio-group" value= {metaDataKey === EDIT ? radioButtonVal : operationRange} onChange={handleRadioChange}>
          {body__radio_group.map((radio__text: any, index: number) => {
            const { label, value } = radio__text;
            return (
              <Radio key={index} value={value}>
                {label}
              </Radio>
            );
          })}
        </Radio.Group>
      </div>
      <div className="editRecurrenceReminderModal__footer">
        <Button className="editRecurrenceReminderModal__footer__cancel-button" onClick={() => toggleModal((prev : boolean) => !prev)}>
          {cancel__button_text}
        </Button>
        <Button
          type="primary"
          className="editRecurrenceReminderModal__footer__open-button"
          onClick={() => {
            toggleModal((prev : boolean) => !prev);
            onOk({operationRange});
          }}
        >
          {primary__button_text}
        </Button>
      </div>
    </RecurrenceInfoModal>
  );
};
